// src/Component/hooks/useDeletePengeluaran.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * useDeletePengeluaran adalah custom hook yang digunakan untuk menghapus data pengeluaran dari backend.
 * @returns { Object } - Mengembalikan fungsi deletePengeluaran, serta status loading dan error.
 */
const useDeletePengeluaran = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk menghapus data pengeluaran di backend.
   * @param { number } id - ID pengeluaran yang akan dihapus.
   * @returns { Promise<boolean> } - Mengembalikan true jika berhasil, false jika gagal.
   */
  const deletePengeluaran = async (id) => {
    setLoading(true);
    setError(null);

    try {
      if (!endpoints.pengeluaran || typeof endpoints.pengeluaran.delete !== 'function') {
        throw new Error('endpoints.pengeluaran.delete is not defined');
      }

      const response = await api.delete(endpoints.pengeluaran.delete(id), {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200 || response.status === 204) {
        return true;
      } else {
        setError('Gagal menghapus data pengeluaran.');
        return false;
      }
    } catch (err) {
      console.error('Error deleting pengeluaran:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        'Terjadi kesalahan saat menghapus data pengeluaran.'
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deletePengeluaran, loading, error };
};

export default useDeletePengeluaran;
